import "./App.css";
import { useState } from "react";
import { OpenCvProvider } from "opencv-react";
import { Box, Container, Backdrop, CircularProgress } from "@mui/material";

import ServingExampleAppBar from "./ServingExampleAppBar";
import ServingExampleAppInput from "./ServingExampleAppInput";
import ServingExampleAppAPISummary from "./ServingExampleAppAPISummary";
import ServingExampleAppMOT from "./ServingExampleAppMOT";
import ServingExampleAppOCR from "./ServingExampleAppOCR";

function Main(props) {
  const [img, setImg] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [isInferencing, setIsInferencing] = useState(false);
  const [took, setTook] = useState(null);

  var ServingExampleAppKind;
  if (process.env.REACT_APP_APP_NAME.toLowerCase() === "ocr") {
    ServingExampleAppKind = ServingExampleAppOCR;
  } else if (process.env.REACT_APP_APP_NAME.toLowerCase() === "mot") {
    ServingExampleAppKind = ServingExampleAppMOT;
  } else {
    console.error(`Invalid app name, ${process.env.REACT_APP_APP_NAME}`);
  }

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isInferencing}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ServingExampleAppBar />
      <Container maxWidth="xl" disableGutters>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mt: "3em",
          }}
        >
          <ServingExampleAppInput
            onImageChange={setImg}
            onFileChange={setImgFile}
            isInferencing={isInferencing}
          />
          <ServingExampleAppAPISummary took={took} msg={msg} />
          <ServingExampleAppKind
            cv={props.cv}
            img={img}
            imgFile={imgFile}
            onChangeMsg={setMsg}
            onChangeIsInferencing={setIsInferencing}
            onChangeTook={setTook}
          />
        </Box>
      </Container>
    </>
  );
}

function MainLoading() {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

function App() {
  const [loaded, setLoaded] = useState(false);
  const [cv, setCv] = useState(null);
  return (
    <OpenCvProvider
      onLoad={(cv) => {
        setLoaded(true);
        setCv(cv);
      }}
    >
      {loaded ? <Main cv={cv} /> : <MainLoading />}
    </OpenCvProvider>
  );
}

export default App;
